export const userDataStoreKey = 'userData';
